import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  onTour: {
    id: 't.onTour',
    defaultMessage: 'On Tour',
  },
  getTickets: {
    id: 't.getTickets',
    defaultMessage: 'Get Tickets',
  },
  onTourIn: {
    id: 't.onTourIn',
    defaultMessage: 'On Tour in',
  },
  via: {
    id: 't.via',
    defaultMessage: 'via',
  },
  concertsBy: {
    id: 't.concertsBy',
    defaultMessage: 'concerts by',
  },
});

export const ArtistEventsConstants = Object.freeze({
  TICKETFLY: 'TICKETFLY',
  MAX_NUM_EVENTS_STATION_EXTRAS: 1,
  MAX_NUM_EVENTS_DEFAULT: 1,
  UTM_MEDIUM: 'utm_medium',
  NOW_PLAYING_PARAM: 'now-playing',
  ARTIST_PAGES_PARAM: 'artist-pages',
});
